<ng-template #afterTitle>
    <app-select-button
        id="active"
        [form]="form"
        [options]="[{ value: 'true', key: 'service.offer.labels.active' | translate }, { value: 'false', key: 'service.offer.labels.inactive' | translate }]"
    ></app-select-button>
</ng-template>

<app-card-table
    #offerTable
    [tableTitle]="'service.settings.group.labelOffers'"
    [afterTitle]="afterTitle"
    [translatePrefix]="prefix"
    [columns]="columns"
    [gridData]="store.data.getSocialServiceOffers()"
    [refreshCallback]="store.api.getSocialServiceOffers"
    [additionalFilter]="additionalFilter()"
    [refreshCallbackFragment]="getSocialServiceOffersFrag"
    (deleteCallbackWithEvent)="deleteOffer($event)"
    (detailCallback)="upsertOffer($event)"
    (createCallback)="upsertOffer()"
>
    <ng-template pTemplate="unitPrice" let-item="item">
        {{ item | formatOfferUnitPrice }}
    </ng-template>
    <ng-template pTemplate="unitPriceExt" let-item="item">
        {{ item | formatOfferUnitPrice:'ext' }}
    </ng-template>
</app-card-table>
